import React, { useState } from "react";
import { getComplaintByApplicationId } from "../../services/complaintService";

export default function HomeComplaintStatus() {
  const [applicationId, setApplicationId] = useState("");
  const [complaint, setComplaint] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    setError("");
    setComplaint(null);

    try {
      const result = await getComplaintByApplicationId(applicationId);
      if (result) {
        setComplaint(result);
      } else {
        setError("❌ No complaint found with this ID.");
      }
      setShowModal(true);
    } catch (err) {
      console.error(err);
      setError("❌ Failed to fetch complaint. Please try again.");
      setShowModal(true);
    }
  };

  const handleClose = () => setShowModal(false);

  return (
    <div className="w-100 h-100 d-flex flex-column">
      <div className="text-center h-100 d-flex flex-column">
        <form
          onSubmit={handleSearch}
          className="home-complaint-status-form d-flex flex-column justify-content-between h-100"
        >
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control rounded-pill text-center"
              id="ComplaintId"
              placeholder="Enter Complaint ID"
              value={applicationId}
              onChange={(e) => setApplicationId(e.target.value)}
              required
            />
            <label htmlFor="ComplaintId">Enter Complaint ID</label>
          </div>
          <button
            type="submit"
            className="btn btn-primary rounded-pill fw-semibold home-action-btn align-self-center"
            style={{ width: "210px", height: "42px" }}
          >
            <i className="fa fa-search me-2"></i>
            Check Status
          </button>
        </form>
      </div>
      <style>{`
        .home-complaint-status-form {
          min-height: 100%;
        }
      `}</style>

      {/* Modal */}
      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Complaint Status</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>
             <div className="modal-body">
  {complaint ? (
    <div>
      {(() => {
        const remarks = complaint.remarks || complaint.reason;
        return remarks ? (
          <p>
            <strong>Remarks:</strong> {remarks}
          </p>
        ) : null;
      })()}
      <p>
        <strong>Application ID:</strong> {complaint.applicationUniqueID}
      </p>
      <p>
        <strong>Complainant Name:</strong> {complaint.complainantName}
      </p>
      <p>
        <strong>Status:</strong>{" "}
        <span
          style={{
            padding: "4px 10px",
            borderRadius: "12px",
            color: "#fff",
            backgroundColor:
              complaint.status === "Completed"
                ? "#28a745"   // green
                : complaint.status === "In Process"
                ? "#ffc107"   // yellow
                : complaint.status === "Rejected"
                ? "#dc3545"   // red
                : "#6c757d",  // gray for unknown
            fontWeight: "bold",
          }}
        >
          {complaint.status}
        </span>
      </p>
      <p>
        <strong>Complaint Head:</strong> {complaint.complaintHead}
      </p>
      <p>
        <strong>Complaint Details:</strong> {complaint.complaintDetails}
      </p>
    </div>
  ) : (
    <p className="text-danger">{error}</p>
  )}
</div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
